import { AppState } from './reducers';
import { ConfigService } from './services/config.service';

export const selectTradingAddressAvailabilityFeedIdAppSetting = (state: AppState) =>
  +state.appSettings[ConfigService.TRADING_ADDRESS_AVAILABILITY_FEED_ID];

export const selectIsGenerativeAiEnabledAppSetting = (state: AppState) => state.appSettings[ConfigService.IS_GENERATIVE_AI_ENABLED];

export const selectEnvironmentAppSetting = (state: AppState) => state.appSettings[ConfigService.ENVIRONMENT];

export const selectStudyAccessAllowedAddressesAppSetting = (state: AppState) => state.appSettings[ConfigService.ALLOWED_ADDRESSES_FOR_STUDY_ACCESS];

export const selectTPBMVersionAppSetting = (state: AppState) => state.appSettings[ConfigService.TPBM_VERSION_INFO];

export const selectListedUnlistedFilterAvailabilityFeedIdAppSetting = (state: AppState) =>
  +state.appSettings[ConfigService.LISTED_UNLISTED_FILTER_AVAILABILITY_FEED_ID];

export const selectTradingAddressAvailabilityTPCOrbisFeedIdAppSetting = (state: AppState) =>
  +state.appSettings[ConfigService.TRADING_ADDRESS_AVAILABILITY_TPCORBIS_FEED_ID];

export const selectIndustryClassificationFilterPassIfNAActivationFromAppSetting = (state: AppState) =>
  state.appSettings[ConfigService.INDUSTRY_CLASSIFICATION_FILTER_PASSIFNA_ACTIVATION_FROM];
